<div class="modal-header">
  <h5 class="modal-title" i18n="@@InviteCustomerHeader">Bitte überprüfen</h5>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="formService.form" (ngSubmit)="onSubmit()">
    <div class="d-flex flex-column" style="gap: 0.5rem">
      
      <div class="form-check">
        <label class="form-check-label" for="confirmName" i18n="@@confirmNameLabel">
          <input id="confirmName" class="form-check-input" type="checkbox" formControlName="confirmName" />
          Name vollständig
        </label>
        <div class="error">
          <em *ngIf="formService.validateControl('confirmName') && formService.hasError('confirmName', 'required')"
            i18n="@@ConfirmNameRequiredError">Pflichtfeld</em>
        </div>
      </div>

      <div class="form-check">
        <label class="form-check-label" for="confirmEmail" i18n="@@confirmEmailLabel">
          <input id="confirmEmail" class="form-check-input" type="checkbox" formControlName="confirmEmail" />
          E-Mail korrekt
        </label>
        <div class="error">
          <em *ngIf="formService.validateControl('confirmEmail') && formService.hasError('confirmEmail', 'required')"
            i18n="@@ConfirmEmailRequiredError">Pflichtfeld</em>
        </div>
      </div>

      <div class="form-check">
        <label class="form-check-label" for="confirmChargingStations" i18n="@@confirmChargingStationsLabel">
          <input id="confirmChargingStations" class="form-check-input" type="checkbox" formControlName="confirmChargingStations" />
          Ladepunkte angelegt
        </label>
        <div class="error">
          <em *ngIf="formService.validateControl('confirmChargingStations') && formService.hasError('confirmChargingStations', 'required')"
            i18n="@@ConfirmChargingStationsRequiredError">Pflichtfeld</em>
        </div>
      </div>

      <div class="form-check">
        <label class="form-check-label" for="confirmRfid" i18n="@@confirmRfidLabel">
          <input id="confirmRfid" class="form-check-input" type="checkbox" formControlName="confirmRfid" />
          RFID-Karten angelernt
        </label>
        <div class="error">
          <em *ngIf="formService.validateControl('confirmRfid') && formService.hasError('confirmRfid', 'required')"
            i18n="@@ConfirmRfidRequiredError">Pflichtfeld</em>
        </div>
      </div>

    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="float-end">
    <button class="btn btn-danger text-white me-1" type="button" data-bs-dismiss="modal" (click)="close()" i18n="@@CancelButton">
      Abbrechen
    </button>
    <form class="float-end" [formGroup]="formService.form" (ngSubmit)="onSubmit()">
      <button class="btn btn-yellow" type="submit" [disabled]="!formService.form.valid || this.isButtonDisabled" i18n="@@SendInvitationButton">
        Einladung absenden
      </button>
    </form>
  </div>
</div>
